"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ShareExpiredLinkError;
// eslint-disable-next-line no-unused-vars
function ShareExpiredLinkError(code, message) {
  var instance = new Error(message);
  instance.message = message;
  instance.code = code;
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, ShareExpiredLinkError);
  }
  return instance;
}
ShareExpiredLinkError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
if (Object.setPrototypeOf) {
  Object.setPrototypeOf(ShareExpiredLinkError, Error);
} else {
  ShareExpiredLinkError.__proto__ = Error;
}